export default "__VITE_ASSET__87493d34__"